import { render } from "./FaqExpandable.vue?vue&type=template&id=062110ea"
import script from "./FaqExpandable.vue?vue&type=script&lang=js"
export * from "./FaqExpandable.vue?vue&type=script&lang=js"

import "./FaqExpandable.vue?vue&type=style&index=0&id=062110ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__